module.exports = __webpack_public_path__ + "assets/img/Structure_item1.5c9034de.png";